<template>
  <v-container
    id="city-get"
  >
    <sala-header
      :payload="payload"
      v-if="isAuthenticated"
    >
    </sala-header>
  </v-container>
</template>

<script>
import SalaHeader from './SalaHeader'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    SalaHeader
  },
  data () {
    return {
      municipioId: this.$route.params.id,
      medalWidth: '80px',
      showMedalGrey: false,
      payload: {
        acompanhamentos: [],
        temas: []
      },
      editReport: false,
      nomesAcompanhamentos: [],
      pontosAcompanhamentos: [],
      nomesTemas: [],
      percentuaisTemas: [],
      lineChart: {},
      lineChartOptions: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              suggestedMin: 0
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [ {
            ticks: {
              beginAtZero: true,
              suggestedMin: 0,
              max: 100
            },
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      },
      barChart: {},
      barChartOptions: {
        scales: {
          yAxes: [{
            gridLines: {
              display: true
            }
          }],
          xAxes: [ {
            ticks: {
              beginAtZero: true,
              suggestedMin: 0,
              max: 100
            },
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      },
      estado: this.$store.state.uf
    }
  },
  methods: {
    ...mapActions([
      'setLoading',
      'setConsultorCondutorMunicipio',
      'setConsultorEspecialistaMunicipio',
      'setAnalistaMunicipio',
      'setADMunicipio',
      'setCityName',
      'setCityId'
    ])
  },
  mounted () {
    if (this.$store.state.uf === 'SC') {
      this.medalWidth = '160px'
    }

    if (this.$store.state.uf !== 'SC') {
      this.showMedalGrey = true
    }

    document.getElementsByClassName('v-content__wrap')[0].style.background = 'none'
  },
  computed: {
    ...mapGetters([
      'loading',
      'isAdmin',
      'isConsultorCondutorMunicipio',
      'isConsultorEspecialistaMunicipio',
      'isADMunicipio',
      'isAuthenticated',
      'isSPFesp',
      'isSPFespEspecial',
      'isSPCoordenador'
    ])
  }
}
</script>

<style lang="scss">@import './style.scss';</style>
